import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import { UserRole, UserStatus } from '@spi/shared';
import { PageMeta } from '../shared/PageMeta';
import { DonorDashboard } from './DonorDashboard';
import { RecipientDashboard } from './RecipientDashboard';
import { AdminDashboard } from './AdminDashboard';
import { PendingApproval } from './PendingApproval';

export function DashboardPage() {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-spi-green border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/marketplace/login" replace />;
  }

  if (user!.status !== UserStatus.APPROVED) {
    return <PendingApproval />;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <PageMeta title="Dashboard" description="Your Second Chance Seed Network dashboard" path="/marketplace/dashboard" />
      <h2 className="text-3xl mb-6">Welcome, {user!.firstName}</h2>
      {user!.role === UserRole.ADMIN && <AdminDashboard />}
      {user!.role === UserRole.DONOR && <DonorDashboard />}
      {user!.role === UserRole.RECIPIENT && <RecipientDashboard />}
    </div>
  );
}
